import { useGetBuyerSpendingLimit } from '@api/lendingAPI/lapiHooks';
import { tracking } from '@iwoca/frontend-tracking-library';

import { SpendingLimitBar } from './SpendingLimitBar';
import { FormattedCurrency } from '../../../../../iwIntlProvider/FormattedCurrency';
import styles from '../SpendingLimitCard.module.css';
import {
    checkHasThirtyDayAndThreeMonthLimit,
    formatDuration
} from './formatDuration';
import { useGetFlexiLoanAmount } from '../../Dashboard.helpers';

export const ValidLimits = ({
    setIsSpendingLimitDrawerOpen
}: {
    setIsSpendingLimitDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
    const { buyerSpendingLimit, loadingBuyerSpendingLimit } =
        useGetBuyerSpendingLimit();
    const { flexiLoanAmount, loadingFlexiLoanAmount } = useGetFlexiLoanAmount();
    const spendingLimit = buyerSpendingLimit?.active_spending_limit;
    if (loadingBuyerSpendingLimit || !spendingLimit || loadingFlexiLoanAmount)
        return null;
    // Ensure the group formatting only happens when customer is active for the thirty day limit
    const hasThirtyDayAndThreeMonthLimit = checkHasThirtyDayAndThreeMonthLimit(
        buyerSpendingLimit?.spending_limits
    );

    return (
        <div className={styles.limits}>
            <div className={styles.left}>
                <div className={styles.remainingLimitHeader}>
                    <div>
                        You have{' '}
                        <FormattedCurrency
                            className={styles.remainingLimitAmount}
                            value={spendingLimit.available_amount}
                        />{' '}
                        left to spend
                    </div>
                </div>
                {spendingLimit.max_amount === 150 && flexiLoanAmount && (
                    // We are using max_amount of £150 as a proxy for "the customer has had their offer reduced by outstanding flexi loan(s)"
                    <div className="my-s text-s font-reg text-core-40">
                        *Your available spending is limited due to active loans.
                    </div>
                )}
                <div className={styles.interestRateLabel}>
                    *Interest rate is dependent on supplier
                </div>
            </div>
            <div className={styles.right}>
                <div className={styles.spendingLimitAmount}>
                    <div>
                        Spending limit:{' '}
                        <FormattedCurrency value={spendingLimit.max_amount} />
                    </div>
                </div>
                <div className={styles.spendingLimitDurationLabel}>
                    {formatDuration({
                        duration: spendingLimit.duration_in_months,
                        groupSameLimits: hasThirtyDayAndThreeMonthLimit
                    })}{' '}
                    purchases{' '}
                    <button
                        onClick={() => {
                            tracking.ampli.spendingLimitViewedOtherTerms();
                            setIsSpendingLimitDrawerOpen(true);
                        }}
                        className={styles.otherTermsButton}
                    >
                        Other terms
                    </button>
                </div>
            </div>
            <div className={styles.bar}>
                <SpendingLimitBar status="valid" />
            </div>
        </div>
    );
};
